import { ApplicationVersion } from '@models/application-version.model';
import { TestCase } from '@modules/test-development/models/test-case.model';
import { ApplicationType, ResultConstant } from '@testsigma/organism';

window.tsTracker = {};

// When user clicks on Continue or "Try Sample Project"
const onClickContinueOrTrySampleProject = (
  isOnboarding: boolean,
  isCreate: boolean,
  projectName: string,
  applicationType: ApplicationType,
) => {
  window?.amplitude?.getInstance()?.logEvent('Selected Project Type', {
    Source: isOnboarding ? 'Onboarding' : 'Authoring',
    Flow: isCreate ? 'Create' : 'Sample',
    'Project Name': projectName,
    'Application Type': applicationType,
  });
};

// When user clicks on Continue or "Try Sample Project"
const onClickTrySampleProjectFromAuthoringPage = () => {
  window?.amplitude?.getInstance()?.logEvent('Selected Project Type', {
    Source: 'Authoring',
    Flow: 'Sample',
    'Project Name': '',
    'Application Type': window?.tsGlobal?.applicationType,
  });
};
window.tsTracker.onClickTrySampleProjectFromAuthoringPage =
  onClickTrySampleProjectFromAuthoringPage;

// when user clicks on Install Extension or Remind later
const onInstallExtensionAction = (
  isOnboarding: boolean,
  isInstallButtonClicked: boolean,
) => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Install Recorder', {
    Source: isOnboarding ? 'Onboarding' : 'Authoring',
    'Install Extension': isInstallButtonClicked ? 'Yes' : 'No',
  });
};
window.tsTracker.onInstallExtensionAction = onInstallExtensionAction;

// When trial user hits enter to add a step or clicks on add new step
const sendOnAddStepEvent = (testCaseId: number, nlp: string) => {
  window?.amplitude?.getInstance()?.logEvent('Added Step', {
    'TestCase ID': testCaseId,
    NLP: nlp,
  });
};

// When the Introduction Video is shown to user
const viewedIntroductionVideo = () => {
  window?.amplitude
    ?.getInstance()
    ?.logEvent('Viewed Introduction Video Popup', {});
};
window.tsTracker.viewedIntroductionVideo = viewedIntroductionVideo;

// When user clicks on "OK Got it" or "Dismiss"
const playedIntroductionVideo = (isDismissed: boolean) => {
  window?.amplitude?.getInstance()?.logEvent('Played Introduction Video', {
    Dismissed: isDismissed ? 'Yes' : 'No',
  });
};
window.tsTracker.playedIntroductionVideo = playedIntroductionVideo;

// NLP + Test Authoring
const viewedNLPTestAuthoringPopup = (
  isNaturalLanguageShown: boolean,
  isTestDataShown: boolean,
  isStepTypeShown: boolean,
) => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Authoring PopUp', {
    'Natural Language': isNaturalLanguageShown ? 'Yes' : 'No',
    'Test Data': isTestDataShown ? 'Yes' : 'No',
    'Step Type': isStepTypeShown ? 'Yes' : 'No',
    'Application Type': window?.tsGlobal?.applicationType,
  });
};
window.tsTracker.viewedNLPTestAuthoringPopup = viewedNLPTestAuthoringPopup;

// When User clicks on Record TestCase
const recordTestClicked = (
  testCaseId: number,
  applicationType: ApplicationType,
) => {
  window?.amplitude?.getInstance()?.logEvent('Clicked on Record', {
    'Test Case ID': testCaseId,
    'Application Type': applicationType,
  });
};

// When User is shown Record Tooltip
const onViewRecordTooltip = () => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Record Tooltip', {});
};
window.tsTracker.onViewRecordTooltip = onViewRecordTooltip;

// When User clicks on Dismiss for Record in the Tooltip
const onDismissRecordTooltip = (isDismissed: boolean) => {
  window?.amplitude?.getInstance()?.logEvent('Dismissed Record Tooltip', {
    Dismissed: isDismissed ? 'Yes' : 'No',
    'Application Type': window?.tsGlobal?.applicationType,
  });
};
window.tsTracker.onDismissRecordTooltip = onDismissRecordTooltip;

// When User clicks on Run TestCase
const runTestClicked = (testCase: TestCase, version: ApplicationVersion) => {
  window?.amplitude?.getInstance()?.logEvent('Clicked on Run', {
    TestCaseName: testCase.name,
    TestCaseID: testCase.id,
    ApplicationType: version.application.applicationType,
  });
};

// When User clicks on Run TestCase
const runTooltipViewed = () => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Run Tooltip', {});
};
window.tsTracker.runTooltipViewed = runTooltipViewed;

// When User clicks on Run TestCase
const runTooltipDismissed = (isDismissed: boolean) => {
  window?.amplitude?.getInstance()?.logEvent('Dismissed Run Tooltip', {
    Dismissed: isDismissed ? 'Yes' : 'No',
    'Application Type': window?.tsGlobal?.applicationType,
  });
};
window.tsTracker.runTooltipDismissed = runTooltipDismissed;

// When user is shown the Result Tooltip
const onViewResultTooltip = () => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Result ToolTip', {});
};
window.tsTracker.onViewResultTooltip = onViewResultTooltip;

// When user clicks Dismiss or "OK Got it"-> For Watch Video
const onDismissResultTooltip = () => {
  window?.amplitude?.getInstance()?.logEvent('Dismissed Result Tooltip', {});
};
window.tsTracker.onDismissResultTooltip = onDismissResultTooltip;

// If User clicks on "Ok got it" in the Result Tooptip
const onWatchResultVideoTooltip = () => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Watch Video Tooltip', {});
};
window.tsTracker.onWatchResultVideo = onWatchResultVideoTooltip;

// When user clicks on the Video Icon in the App
const onViewResultVideo = (
  testCaseId: number,
  applicationType: ApplicationType,
) => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Result Video CTA', {
    'Test Case ID': testCaseId,
    'Application Type': applicationType,
  });
};

// When user watches the video
const onWatchResultVideo = (
  testCaseId: number,
  applicationType: ApplicationType,
) => {
  window?.amplitude?.getInstance()?.logEvent('Watched Result Video', {
    'Test Case ID': testCaseId,
    'Application Type': applicationType,
  });
};

// on view talk to expert
const onViewTalkToExpert = () => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Talk to Expert', {});
};
window.tsTracker.onViewTalkToExpert = onViewTalkToExpert;

// on view talk to expert
const onDismissTalkToExpert = () => {
  window?.amplitude?.getInstance()?.logEvent('Dismissed Talk to Expert', {});
};
window.tsTracker.onDismissTalkToExpert = onDismissTalkToExpert;

// on view talk to expert
const onClickTalkToExpert = () => {
  window?.amplitude?.getInstance()?.logEvent('Clicked Talk to Expert', {});
  window?.fcWidget?.open({
    replyText:
      'Hey, can you help me on this failure, Test Case name : ' +
      document.querySelector('a[href*="/td/cases/"]').innerText +
      ', URL is :' +
      window.location.href,
  });
};
window.tsTracker.onClickTalkToExpert = onClickTalkToExpert;

// schedule demo view
const onViewScheduleDemoPopup = (source: string) => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Schedule Demo Popup', {
    Source: source,
  });
};
window.tsTracker.onViewScheduleDemoPopup = onViewScheduleDemoPopup;

// schedule demo dismiss/chat/schedule
const onDismissScheduleDemoPopup = (
  source: string,
  action: 'Chat' | 'Schedule' | 'Dismiss',
) => {
  window?.amplitude?.getInstance()?.logEvent('Clicked on Schedule Demo Popup', {
    Source: source,
    Action: action,
  });
  if (action == 'Chat') {
    window?.fcWidget?.open({
      replyText:
        "Hello! I could use some assistance with my recent experience on your product. Specifically, I'm looking for help with...",
    });
  }
};
window.tsTracker.onDismissScheduleDemoPopup = onDismissScheduleDemoPopup;

// When Create Test Case Tooltip is shown
const viewedCreateTestTooltip = () => {
  window?.amplitude?.getInstance()?.logEvent('Viewed Create Test Tooltip', {});
};
window.tsTracker.viewedCreateTestTooltip = viewedCreateTestTooltip;

// When Create Test Case Tooltip is dismissed
const dismissedCreateTestTooltip = () => {
  window?.amplitude
    ?.getInstance()
    ?.logEvent('Dismissed Create Test Tooltip', {});
};
window.tsTracker.dismissedCreateTestTooltip = dismissedCreateTestTooltip;

// When user clicks on Create Test Case
const clickedCreateTestCase = (
  testCaseID: number,
  applicationType: ApplicationType,
) => {
  window?.amplitude?.getInstance()?.logEvent('Clicked Create Test Case', {
    'Test Case ID': testCaseID,
    'Applicaiton type': applicationType,
  });
};

// When user clicks "Cancel" or "Next" for step one
const createTestPlanEvent1 = (
  testPlanName: string,
  applicationType: ApplicationType,
  descriptionProvided: boolean,
  descriptionDetails: string,
  isTestsigmaLab: boolean,
  created: boolean,
  switchToOldUIClicked: boolean,
  isTrialAccount: boolean,
) => {
  window?.amplitude?.getInstance()?.logEvent('Create Test Plan(Step 1)', {
    testPlanName,
    applicationType,
    descriptionProvided,
    descriptionDetails,
    testLab: isTestsigmaLab ? 'TestSigma' : 'Local',
    created,
    switchToOldUIClicked,
    accountStatus: isTrialAccount ? 'Trial' : 'Paid',
  });
};

// Raise When user clicks next on Test Suite Selection step 2 , "Test Suites and Machines selection"
const createTestPlanEvent2 = (
  testPlanName: string,
  applicationType: ApplicationType,
  isCrossBrowserTesting: boolean,
  isAddTestSuiteClicked: boolean,
  isTrialAccount: boolean,
) => {
  window?.amplitude?.getInstance()?.logEvent('Create Test Plan(Step 2)', {
    testPlanName,
    applicationType,
    testingType: isCrossBrowserTesting ? 'Cross Browser' : 'Distributed',
    isAddTestSuiteClicked,
    accountStatus: isTrialAccount ? 'Trial' : 'Paid',
  });
};

// Raise When user clicks "Create"
const createTestPlanEvent3 = (
  testPlanName: string,
  testPlanId: number,
  applicationType: ApplicationType,
  sendNotification: boolean,
  sendNotificationCriteria: ResultConstant[],
  additionalSettingsSelected: boolean,
  recoverySettingsSelected: boolean,
  switchToOldUIClicked: boolean,
  isTrialAccount: boolean,
) => {
  window?.amplitude?.getInstance()?.logEvent('Create Test Plan(Step 3)', {
    testPlanName,
    testPlanId,
    applicationType,
    sendNotification,
    sendNotificationCriteria,
    additionalSettingsSelected,
    recoverySettingsSelected,
    switchToOldUIClicked,
    accountStatus: isTrialAccount ? 'Trial' : 'Paid',
  });
};

// Raise if user clicks on Test Plan details page "Run Now" Button
const onClickTestPlanRunNow = (testPlanName: string, testPlanId: number) => {
  window?.amplitude?.getInstance()?.logEvent('Clicked Test Plan Run Now', {
    testPlanName,
    testPlanId,
  });
};

// On new signup
const onNewSignup = () => {
  window?.amplitude
    ?.getInstance()
    ?.logEvent('Selected Created New Account', {});
};

// Join to existing account
const onJoinToExistingAccount = (
  source: string,
  flow: string,
  projectName: string,
  applicationType: ApplicationType,
) => {
  window?.amplitude?.getInstance()?.logEvent('Selected Join Account', {
    Source: source,
    Flow: flow,
    'Project Name ': projectName,
    'Application Type': applicationType,
  });
};

// On skip tour
const onSkipTour = () => {
  window?.amplitude
    ?.getInstance()
    ?.logEvent('Clicked Skip Tour', { URL: window.location.href });
};
window.tsTracker.skipTour = onSkipTour;

const leapUIPopUpShown = () => {
  window?.amplitude
    ?.getInstance()
    ?.logEvent('Viewed Leap UI Migration Popup', {});
};

window.tsTracker.leapUIPopUpShown = leapUIPopUpShown;

const commandCenterLaunch = () => {
  window?.amplitude
    ?.getInstance()
    ?.logEvent('Command Center Launched', { URL: window.location.href });
};

const commandCenterExecute = (command) => {
  window?.amplitude?.getInstance()?.logEvent('Command Center Executed', {
    command,
    URL: window.location.href,
  });
};

const AmplitudeEventService = {
  onClickContinueOrTrySampleProject,
  recordTestClicked,
  runTestClicked,
  createTestPlanEvent1,
  createTestPlanEvent2,
  createTestPlanEvent3,
  onClickTestPlanRunNow,
  onViewResultVideo,
  onWatchResultVideo,
  sendOnAddStepEvent,
  onInstallExtensionAction,
  onNewSignup,
  onJoinToExistingAccount,
  clickedCreateTestCase,
  commandCenterLaunch,
  commandCenterExecute,
};

export default AmplitudeEventService;
